import { CategorySortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useInventoryCategoriesQuery = createQueryHook(
  'inventory.categories',
  (params: {
    searchTerm?: string;
    sorting?: CategorySortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    categories: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.categories.entries.map((category) => ({
        id: category.id,
        name: category.name,
      })) ?? [],
  },
);
